import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useCreateStaticDataType = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('createStaticDataType', {
    onSuccess: async (response) => {
      toast.success(response.message);
      await queryClient.invalidateQueries({ queryKey: ['static-data-type'] });
    },
    onError: (error: { message: string }) => toast.error(error.message),
  });

  return { mutateAsync, isPending };
};

export const useUpdateStaticDataType = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('updateStaticDataType', {
    onSuccess: async (response) => {
      toast.success(response.message);
      await queryClient.invalidateQueries({ queryKey: ['static-data-type'] });
    },
    onError: (error: { message: string }) => toast.error(error.message),
  });

  return { mutateAsync, isPending };
};

export const useDeleteStaticDataType = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('deleteStaticDataType', {
    onSuccess: async (response) => {
      toast.success(response.message);
      await queryClient.invalidateQueries({ queryKey: ['static-data-type'] });
    },
    onError: (error: { message: string }) => toast.error(error.message),
  });

  return { mutateAsync, isPending };
};
